import { css } from "@styled-system/css";
import { flex } from "@styled-system/patterns";

export const wrapperClass = flex({
	alignItems: "center",
	justifyContent: "space-between",
	width: "full",
	paddingX: "4",
	borderRadius: "full",
	border: "1px solid",
	shadow: "contentCard",
	borderColor: "shade.20",
	_hover: { backgroundColor: "secondary.20" },
	gap: "8",
	px: "32",
	py: "10",
});

export const lastUsedLoginMethodClass = css({
	position: "relative",
	borderColor: "primary.100!",
	_after: {
		content: '"zuletzt verwendet"',
		position: "absolute",
		bottom: "0",
		right: "0",
		backgroundColor: "primary.100",
		borderRadius: "full",
		px: "10",
		py: "2",
		fontSize: "12",
		color: "shade.0",
		transform: "translateY(50%)",
	},
});
